import * as yup from "yup";

import { t } from "i18next";

import { FEEDBACK_SUBJECT_EMPTY } from "@/src/components/organisms/FeedbackForm/feedbackSubjectOptions";

import { MAX_FEEDBACK_MESSAGE_LENGTH } from "@/src/config/baanaConfig";

export const createFeedbackFormValidator = () =>
  yup.object().shape({
    email: yup
      .string()
      .trim()
      .email(() => t("feedbackForm.validation.invalidEmail"))
      .required(() => t("feedbackForm.validation.requiredEmail")),
    name: yup.string().optional(),
    mobile: yup.string().optional(),
    issueType: yup
      .string()
      .required(() => t("feedbackForm.validation.requiredSubject"))
      .test(
        "subject-selected",
        () => t("feedbackForm.validation.requiredSubject"),
        (val) => val !== FEEDBACK_SUBJECT_EMPTY
      ),
    message: yup
      .string()
      .trim()
      .max(MAX_FEEDBACK_MESSAGE_LENGTH, () =>
        t("feedbackForm.validation.messageTooLong", {
          max: MAX_FEEDBACK_MESSAGE_LENGTH
        })
      )
      .required(() => t("feedbackForm.validation.requiredMessage"))
  });

export type FeedbackFormValues = yup.InferType<
  ReturnType<typeof createFeedbackFormValidator>
>;
